import { BaseResponse } from "../../../../../../../types/api/api.types";
import { USERS_ENDPOINTS } from "../../../../../../../utils/api/endpoints/usersEndpoints";
import { UpdateSubUserFormSchema } from "./UpdateSubUserForm.types";

const PREFIX = '[updateSubUserENTQuery]'

export const UPDATE_SUB_USER_ENT_QUERY_KEY = 'UPDATE_SUB_USER_ENT'

export const updateSubUserENTQuery = async (subUserId: number, data: UpdateSubUserFormSchema) => {
  console.log(PREFIX, `Requesting update sub user ENT...`);
  const response = await USERS_ENDPOINTS.updateSubUsersENT(subUserId, data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received update sub user ENT response.`);
  return json as BaseResponse;
}